import useAuthStore from "views/hooks/useAuthStore";

export function usePermissions() {
  const userData = useAuthStore(state => state.userData);

  const canExport = userData?.permissions.find((item: string) => item === "central-api.can-export");

  const canUpdateCompany = userData?.permissions.find(
    (item: string) => item === "dashboard.can-display-companies",
  );
  const isDemoClient = userData?.permissions.find(
    (item: string) => item === "neoauth.is-client-without-accounting",
  );

  return { canExport, canUpdateCompany, isDemoClient };
}
